import Padding from '@/components/padding/Padding';
import SiteHeader from '@/components/siteChrome/SiteHeader';
import SiteFooter from '@/components/siteChrome/SiteFooter';
import { Box, Heading as ChakraHeading, Text } from '@chakra-ui/react';
import React from 'react';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalPageLayout = ({
  title,
  lastUpdated,
  children,
}: LegalPageLayoutProps): React.JSX.Element => {
  return (
    <>
      <SiteHeader />
      <main id="main-content" role="main" tabIndex={-1}>
        <Padding verticalPadding={12}>
          <ChakraHeading
            as="h1"
            fontSize={{ base: '4xl', md: '5xl' }}
            style={{ fontFamily: 'Bebas Neue' }}
            mb={2}
          >
            {title}
          </ChakraHeading>
          <Text
            fontSize="sm"
            color="gray.500"
            style={{ fontFamily: 'Lato' }}
            mb={10}
          >
            Last updated: {lastUpdated}
          </Text>
          <Box
            className="legal-prose"
            style={{ fontFamily: 'Lato' }}
            fontSize={{ base: 'md', md: 'lg' }}
            lineHeight="1.7"
          >
            {children}
          </Box>
        </Padding>
      </main>
      <SiteFooter />
    </>
  );
};

export default LegalPageLayout;
